class Registration {
    first_name = '';
    last_name = '';
    password = '';
    email = '';
    name = '';
    oib = '';
    iban = '';
    address = '';
    postal_code = '';
    city = '';
    country = '';
    tax_system = false;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Registration;